import React from "react";

import { localizer } from "../../../Translator.js";

import { Backdrop, CircularProgress } from "@material-ui/core"
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography'
import Tooltip from '@material-ui/core/Tooltip';
import { Grid, Avatar, Badge, Switch, FormControlLabel} from "@material-ui/core";

import { TableRowStyled, TableCellStyled } from '../../common/TableStyled.js'
import DateCustom from "../../Utilities/DateCustom";
import { SnackbarCustom } from "../../Utilities/SnackbarCustom";

import AuthCli from "../../../sdk/AuthCli";
export class UserRow extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      // Indicates if the modal for the user is already open.
      openModal: false,
      openModalLockedOutPermanent: false,

      //user: {},
      userFeatures: {},
      
      //message
      message: null,
      severity: "error",
    }
  }
  componentDidMount() {
    AuthCli.GetUserFeatures(this.props.user.userId).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ message: data.substring(data.indexOf(' ')), severity: "error", })
      }
      else {
        this.setState({ userFeatures: data, message: null })
      }
    })
  }

  /**
   * Set the state open for the user's modal to block/unblock a user for security. Pe has blocked it for n failed attempts.
   * PENDING: To be implemented at Auth service controller.
   */
  handleOpenModal = () => {
    this.setState({ openModal: true })
  }
  
  /**
   * Set the state closed for the user's modal.
   */
  handleCloseModal = () => {
    this.setState({ openModal: false })
  }

  /**
  * Set the state open for the user's modal.
  */
  handleOpenModalLockedOutPermanent = () => {
    this.setState({ openModalLockedOutPermanent: true })
  }
  
  /**
   * Set the state closed for the user's modal.
   */
  handleCloseModalLockedOutPermanent = () => {
    this.setState({ openModalLockedOutPermanent: false })
  }
  
  
  
  /**
   * Set the unlocked state to the user.
   */
  changeLockUser = () => {
    this.setState({ isLoading: true })

    AuthCli.StoreUserFeatures({
      userEmail: this.state.userFeatures.userEmail,
      userId: this.state.userFeatures.userId,
      mfaRequired: this.state.userFeatures.mfaRequired,
      lockedOutPermanent: !this.state.userFeatures.lockedOutPermanent
    }).then(response => {
      if (response.toString().startsWith('[ERR')) {
        this.setState({ message: response.substring(response.indexOf(' ')), severity: "error" })
      } else {
        let message = localizer.formatString(localizer.UserlockResultText, this.state.userFeatures.userEmail, this.state.userFeatures.lockedOutPermanent ? localizer.UserUnLocked : localizer.UserLocked)

        this.setState(previousState => ({
          userFeatures: {
            ...previousState.userFeatures,
            lockedOutPermanent: !this.state.userFeatures.lockedOutPermanent
          },
          message: message, severity: "success"
        }))
      }
      this.setState({ openModalLockedOutPermanent: false })
    })

    this.setState({ isLoading: false })
  }

  handleonClose = () => {
    this.setState({ message: null })
  }


  // TODO: To be implemented at Auth service controller.
  /**
   * Set the locked state to the user for security. Pe has blocked it for n failed attempts.
   * PENDING: To be implemented at Auth service controller.
   */
  lockUser = () => {
      
  }
  /**
   * Set the unlocked state to the user for security. Pe has blocked it for n failed attempts.
   * PENDING: To be implemented at Auth service controller.
   */
  unlockUser = () => {
      
  }

  onMfaChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    let userFeatures = { ...this.state.userFeatures, mfaRequired: value ? AuthCli.MFA_OPTION_EMAIL : null }
    
    AuthCli.StoreUserFeatures(userFeatures).then((msg) => {
      if (msg.startsWith("[ERR")) {
        this.setState({ message: msg.substring(msg.indexOf(' ')) })
      } else {
        this.setState({
          userFeatures: userFeatures,
          message: localizer.formatString(localizer.UserMfaChange, userFeatures.userEmail), severity: "success"
        })
      }
    })
  }

  render() {
    const { user } = this.props
    let securityBlock = user.lockoutEnd != null && new Date(user.lockoutEnd) > Date.now() ? true : false
    let userBlocked = (securityBlock || (this.state.userFeatures && this.state.userFeatures.lockedOutPermanent)) ? true : false
    let userBlockedtext = userBlocked ? localizer.Disable : localizer.Enable
    let isMfaChecked = this.state.userFeatures && this.state.userFeatures.mfaRequired !== null

    return (
      <React.Fragment>
        <TableRowStyled>
         
          <TableCellStyled className="typography-generic tablerow-content" align="center">
            <Grid container direction="row">
              <Grid container item md={3}>
                {/* {(securityBlock || this.state.userFeatures.lockedOutPermanent) ? <i className="fa-solid fa-user font-size-25 color-red"></i> : <i className="fa-solid fa-user font-size-25 color-green"></i>} */}
                <Tooltip className="tooltip-custom-w" title={<Typography className="typography-generic small">{userBlockedtext}</Typography>}>
                  <Badge
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    badgeContent={userBlocked ? <i className="fa-solid fa-minus color-white font-size-7 ml-2"></i> : <i className="fa-solid fa-check color-white font-size-7"></i>}
                    className={userBlocked ? "badge-disable" : "badge-enable"}
                  >
                    <Avatar className="bg-light-green color-green">
                      <Typography className="typography-generic">{user ? user.userEmail.charAt(0).toUpperCase() + user.userEmail.charAt(1).toUpperCase() : "?"}</Typography>
                    </Avatar>
                  </Badge>
                </Tooltip>
              </Grid>
              <Grid container item md={9}>
                <Grid item md={12} style={{ minWidth: 0, padding: 0 }}>
                  <Tooltip title={<Typography className="tooltip-large-text">{user ? user.userEmail : ""}</Typography>}>
                    <Typography className="typography-generic ellipsis">
                      {user ? user.userEmail : ""}
                    </Typography>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>
          </TableCellStyled>
         
         
         
          <TableCellStyled className="typography-generic tablerow-content" align="center">{user.passwordExpiration != null ? DateCustom.formatDate(user.passwordExpiration) : ""}{user.passwordExpiration != null ? " (" + DateCustom.dateDiff(user.passwordExpiration, new Date().toJSON().slice(0, 10).replace(/-/g, '/'), "DAYS") + " " + localizer.Days + ")" : "-"}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center">{user.accessFailedCount}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center">
            {securityBlock ?
              <IconButton className=" button-generic icon-button-locked cursor-none" aria-label={localizer.Unlock} variant="outlined">
                <i className="fa-solid fa-lock"></i>
              </IconButton>
              :
              <IconButton className=" button-generic icon-button-unlocked cursor-none" aria-label={localizer.Lock} component="span" variant="outlined">
                <i className="fa-solid fa-lock-open"></i>
              </IconButton>
            }
          </TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center"><div>{user.lockoutEnd != null ? DateCustom.formatDate(user.lockoutEnd) : ""} </div><div>{user.lockoutEnd != null ? "(" + DateCustom.dateDiff(user.lockoutEnd, new Date().toJSON().slice(0, 10).replace(/-/g, '/'), "DAYS") + " " + localizer.Days + ")" : "-"}</div></TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center">
            {this.state.userFeatures.lockedOutPermanent ?
              <Tooltip className="typography-generic" title={<Typography className="typography-generic">{localizer.Unlock}</Typography>}>
                <IconButton className=" button-generic icon-button-locked" aria-label={localizer.Unlock} variant="outlined" onClick={this.handleOpenModalLockedOutPermanent} >
                  <i className="fa-solid fa-lock"></i>
                </IconButton>
              </Tooltip>
              :
              <Tooltip className="typography-generic" title={<Typography className="typography-generic">{localizer.Lock}</Typography>}>
                <IconButton className=" button-generic icon-button-unlocked" aria-label={localizer.Lock} component="span" variant="outlined" onClick={this.handleOpenModalLockedOutPermanent} >
                  <i className="fa-solid fa-lock-open"></i>
                </IconButton>
              </Tooltip>
            }
          </TableCellStyled>

          <TableCellStyled className="typography-generic tablerow-content" align="center">
            <FormControlLabel className="typography-generic"
              control={<Switch name={"mfaRequired"} color="primary" checked={isMfaChecked} onChange={this.onMfaChange} inputProps={{ 'aria-label': 'secondary checkbox' }} />}
            />
          </TableCellStyled>
        </TableRowStyled>

        {/* modal to unlock/lock the user due to password failure */}
        <Dialog
          open={this.state.openModal}
          onClose={this.handleCloseModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="md"
        >
          <DialogTitle id="alert-dialog-title">
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.handleCloseModal}></i>
            <Typography className="typography-generic dialog-header">{user.lockoutEnd != null ? <i className="fa-solid fa-lock-open"></i> : <i className="fa-solid fa-lock"></i>}&nbsp;&nbsp;{user.lockoutEnd != null ? localizer.UserUnlockModalTitle : localizer.UserLockModalTitle}</Typography>
          </DialogTitle>
         
          <DialogContent dividers={true} className="dialog-content">
            <Grid container direction="row" spacing={4} className="mt-10">
              <Grid container item md={12} direction="row" spacing={4}>
                <Typography className="typography-generic">
                  {user.lockoutEnd != null ? localizer.UserUnlockModalText : localizer.UserLockModalText} {user.userEmail}?
                </Typography>
              </Grid>
              <Grid container item md={12} direction="row" spacing={2} justify="flex-end" className="mt-10">
                <Button className="button-generic dialog-cancel" variant="outlined" onClick={this.handleCloseModal}>{localizer.Cancel}</Button>
                <Button onClick={user.lockoutEnd != null ? this.unlockUser : this.lockUser} variant="contained"
                  className={user.lockoutEnd != null ? "button-generic dialog-primary" : "button-generic dialog-primary"} autoFocus>
                  {user.lockoutEnd != null ? localizer.Unlock : localizer.Lock}
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>

        {/*modal to unblock/block the user administratively */}
        <Dialog
          open={this.state.openModalLockedOutPermanent}
          onClose={this.handleCloseModalLockedOutPermanent}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="md"
        >
          <DialogTitle id="alert-dialog-title">
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.handleCloseModalLockedOutPermanent}></i>
            <Typography className="typography-generic dialog-header">{this.state.userFeatures.lockedOutPermanent ? <i className="fa-solid fa-lock-open"></i> : <i className="fa-solid fa-lock"></i>}&nbsp;&nbsp;{this.state.userFeatures.lockedOutPermanent ? localizer.UserUnlockModalTitle : localizer.UserLockModalTitle}</Typography>
          </DialogTitle>
         
          <DialogContent dividers={true} className="dialog-content">
            <Grid container direction="row" spacing={4} className="mt-10">
              <Grid container item md={12} direction="row" spacing={4}>
                <Typography className="typography-generic">
                  {this.state.userFeatures.lockedOutPermanent ? localizer.UserUnlockModalText : localizer.UserLockModalText} {user.userEmail}?
                </Typography>
              </Grid>
              <Grid container item md={12} direction="row" spacing={2} justify="flex-end" className="mt-10">
                <Button className="button-generic dialog-cancel" variant="outlined" onClick={this.handleCloseModalLockedOutPermanent}>{localizer.Cancel}</Button>
                <Button onClick={this.changeLockUser} variant="contained"
                  className={!this.state.userFeatures.lockedOutPermanent ? "button-generic dialog-primary" : "button-generic dialog-primary"} autoFocus>
                  {this.state.userFeatures.lockedOutPermanent ? localizer.Unlock : localizer.Lock}
                </Button>
              </Grid>
            </Grid>
          </DialogContent>


        </Dialog>
        
        {/* Waiting for service response. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 1350 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }
        {/* Error message for address fields validation */}
        <SnackbarCustom message={this.state.message} severity={this.state.severity} handleonClose={this.handleonClose} />
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/users/sections/UserRow.js